import scrollMonitor from 'scrollmonitor'
import TweenLite from 'gsap'

class AnimatedShape {

  constructor (element) {
    this._element = element
    this._container = element.parentNode
    this._velocity = Math.random() + 0.2
    this._init()
  }

  _init () {
    let watcher = scrollMonitor.create(this._element, { top: -200 })
    let onScrollCallback = this._update.bind(this)

    watcher.enterViewport(() => {
      window.addEventListener("scroll", onScrollCallback);
    })

    watcher.exitViewport(() => {
      window.removeEventListener("scroll", onScrollCallback);
    })
  }


  _update () {
    let rect = this._element.getBoundingClientRect()
    let containerHeight = Math.min(window.innerHeight, this._container.clientHeight)
    let viewPortPercentage = ((-rect.top / containerHeight) +1 ) * 0.5
    let maxOffset = 200
    let currentOffset = Math.max(10, maxOffset * viewPortPercentage)
    // this._element.style['transform'] = 'translate3d(0px, '+ currentOffset +'px, 0px)';
    TweenLite.to(this._element, this._velocity, {
      css: {y: currentOffset},
      ease: 'Power1.easeOut'
    })
  }
}

export default AnimatedShape
